import React, {Fragment} from "react";
import { SmartErrorDiv } from "./SmartErrorDiv";

import './FormInput.scss';
import IconTooltip from "ui/Tooltip/IconTooltip";

export const emailPattern = {value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: "invalid email address"}
export const phonePattern = {value: /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm, message: "invalid telephone number"}

const FormInput = ( { onClickEdit, register, width, pattern, readOnly, label, sectionName, name, style, className, formErrors, maxLength, required, showEditIcon = false, editLabel="Edit" } ) =>
{
    const classText = className === undefined ? "form-control" : '' ;
    const styleObj = style === undefined ? {} : style ;

    const showLabel = label !== undefined && label !== null && label !== '' ;

    const inputOnlyField = () =>
    {
        return <input readOnly={readOnly}
               className={classText} {...register(sectionName + '.' + name, {
            required: required,
            maxLength: maxLength,
            pattern: pattern
        })} />
    }

    const editIconField = () =>
    {
        return (
            <Fragment>
                <div className='input-with-icon'>
                    <div>
                        <input readOnly={readOnly}
                               className={classText} {...register(sectionName + '.' + name, {
                            required: required,
                            maxLength: maxLength,
                            pattern: pattern
                        })} />
                    </div>
                    <div>
                        <IconTooltip onClick={() => onClickEdit ()} placement='top' text={editLabel} style={{marginRight: '10px'}} icon="glyphicon-pencil" color="var(--s360-icon-blue)"/>
                    </div>
                </div>
            </Fragment>
        )
    }

    return (
        <Fragment>
            { showLabel === true &&  <label className='col-form-label'>{label}</label> }
            { showEditIcon === false && inputOnlyField() }
            { showEditIcon === true &&  editIconField() }
            <SmartErrorDiv sectionName={sectionName}  name={name} maxLength={maxLength} formErrors={formErrors} />
        </Fragment>
    )
}

export {FormInput} ;
